module.exports = "use Symfony\\Component\\Validator\\Constraints as Assert;\n\n//...\n\n    /**\n     * @ORM\\Column(type=\"string\")\n     * @Assert\\Length(min=2)\n     */\n    private $fullName;"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/entity-sale-2.txt
// module id = 641
// module chunks = 94772797177096